<script lang="ts">
    import Pharmacy from './Pharmacy.svelte'
    import PharmacyAwait from './PharmacyAwait.svelte'
    const dateObj = new Date()
    let currentMonthNumber = dateObj.getMonth()
    let currentYearNumber = dateObj.getFullYear()
    let currentDayNumber = dateObj.getDate()
    let selectedDayNumber = currentDayNumber
    let selectedYearNumber = currentYearNumber
    let selectedMonthNumber = currentMonthNumber
    let lastDayOfMonthNumber = new Date(currentYearNumber, currentMonthNumber - 1, 0).getDate()
    let previousMontName = new Date(currentYearNumber, currentMonthNumber - 1).toLocaleDateString("default", {
        month: "long"
    })
    let pharmacy
    let date
    let monthName = new Date(selectedYearNumber, selectedMonthNumber).toLocaleDateString("default", {
        month: "long"
    })
    let currentDate
    let nextDate
    async function fetchDate(date: string) {
        let res = await fetch("/pharmacy/getByDate/" + date);
        let data = await res.json()
        pharmacy = data.data
    }
    function buildDate() {
        if (selectedMonthNumber + 1 < 10) {
            if (selectedDayNumber < 10) {
                date = "0" + String(selectedDayNumber) + ".0" + String(selectedMonthNumber + 1) + "." + String(
                    selectedYearNumber)
            } else {
                date = String(selectedDayNumber) + ".0" + String(selectedMonthNumber + 1) + "." + String(
                    selectedYearNumber)
            }
        } else {
            if (selectedDayNumber < 10) {
                date = "0" + String(selectedDayNumber) + "." + String(selectedMonthNumber + 1) + "." + String(
                    selectedYearNumber)
            } else {
                date = String(selectedDayNumber) + "." + String(selectedMonthNumber + 1) + "." + String(
                    selectedYearNumber)
            }
        }
        currentDate = new Date(selectedYearNumber, selectedMonthNumber, selectedDayNumber)
        nextDate = new Date(currentDate)
        nextDate.setDate(currentDate.getDate() + 1)
        currentDate = new Date(currentDate).toLocaleDateString('default', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        })
        nextDate = new Date(nextDate).toLocaleDateString('default', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        })
    }
    buildDate()
    let promise = fetchDate(date)
</script>
<div class="grid grid-cols-2 mt-3 ml-3 justify-items-stretch" style="width: 800px; height:520px;">
    <div class="text-4xl font-bold col-span-2 justify-self-center mt-3">
        Apotheken-Notdienst
    </div> 
    <div class="text-lg col-span-2 justify-self-center">
        {currentDate} 8.00Uhr - {nextDate} 8.00Uhr
    </div>
    <div class="col-start-1">
        {#await promise}
            <PharmacyAwait large={true} />
        {:then}
            <Pharmacy pharmacy={pharmacy} date={date} large={true}/>
        {/await}
    </div> 
    <div class="col-start-2 justify-self-center" style="margin-top:280px;">
        <img src="logo.png" alt="">
    </div> 
    <div class="col-start-2 justify-self-start">
        Alle Angaben ohne Gewähr!
    </div>
</div>